<template>
  <div class="pa-2">
    <v-layout row wrap>
      <v-flex xs12>
        <h3 class="mb-2">API Server</h3>
      </v-flex>

      <v-flex xs12 sm6 md4 lg3 pa-1>
        <status-tile
          title="Progressive Transportation"
          :status="boardingTile.status"
          :headline="boardingTile.headline"
          :subline="boardingTile.subline"
          clickable
          @click="$emit('navigate-tab', 'progressive-transportation')"
        />
      </v-flex>

      <v-flex xs12 sm6 md4 lg3 pa-1>
        <status-tile
          title="Pricing Loop"
          :status="pricingTile.status"
          :headline="pricingTile.headline"
          :subline="pricingTile.subline"
          clickable
          @click="$emit('navigate-tab', 'pricing')"
        />
      </v-flex>

      <v-flex xs12 sm6 md4 lg3 pa-1>
        <status-tile
          title="Scheduled Jobs"
          :status="scheduledJobsTile.status"
          :headline="scheduledJobsTile.headline"
          :subline="scheduledJobsTile.subline"
          clickable
          @click="$emit('navigate-tab', 'scheduled-jobs')"
        />
      </v-flex>

      <v-flex xs12 sm6 md4 lg3 pa-1>
        <status-tile
          title="Message Queue"
          :status="messageQueueTile.status"
          :headline="messageQueueTile.headline"
          :subline="messageQueueTile.subline"
          clickable
          @click="$router.push({ name: 'advanced-message-queue' })"
        />
      </v-flex>

      <v-flex xs12 class="mt-3">
        <h3 class="mb-2">Map API Server</h3>
      </v-flex>

      <v-flex xs12 sm6 md4 lg3 pa-1>
        <status-tile
          title="Geo Backup"
          :status="geoBackupTile.status"
          :headline="geoBackupTile.headline"
          :subline="geoBackupTile.subline"
          clickable
          @click="$emit('navigate-tab', 'map-api')"
        />
      </v-flex>

      <v-flex xs12 sm6 md4 lg3 pa-1>
        <status-tile
          title="Request Queues"
          :status="requestQueuesTile.status"
          :headline="requestQueuesTile.headline"
          :subline="requestQueuesTile.subline"
          clickable
          @click="$emit('navigate-tab', 'map-api')"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import StatusTile from '../components/StatusTile.vue'
import { formatAgeShort } from '../components/status-mapping'

export default {
  name: 'realtime-diagnostics-overview-tab',
  components: {
    StatusTile
  },
  props: {
    apiOverview: {
      type: Object,
      default: null
    },
    mapApiOverview: {
      type: Object,
      default: null
    }
  },
  computed: {
    apiSystems () {
      return this.apiOverview && this.apiOverview.systems ? this.apiOverview.systems : {}
    },
    mapSystems () {
      return this.mapApiOverview && this.mapApiOverview.systems ? this.mapApiOverview.systems : {}
    },
    boardingTile () {
      const system = this.apiSystems.boardingPipeline || {}
      return {
        status: system.status || 'unknown',
        headline: formatAgeShort(system.lastActivityAgeSeconds),
        subline: this.safeQueueLine(system.queue)
      }
    },
    pricingTile () {
      const system = this.apiSystems.pricingLoop || {}
      return {
        status: system.status || 'unknown',
        headline: formatAgeShort(system.lastActivityAgeSeconds),
        subline: (system.activeTrips || 0) + ' active trips'
      }
    },
    scheduledJobsTile () {
      const system = this.apiSystems.scheduledJobs || {}
      const totals = system.totals || {}
      const failing = totals.failing || 0
      const overdue = totals.overdue || 0
      const headline = failing || overdue
        ? (failing + ' failing, ' + overdue + ' overdue')
        : 'All healthy'
      return {
        status: system.status || 'unknown',
        headline: headline,
        subline: 'Last run: ' + formatAgeShort(system.lastRunAgeSeconds)
      }
    },
    messageQueueTile () {
      const system = this.apiSystems.messageQueue || {}
      return {
        status: system.status || 'unknown',
        headline: (system.pendingCount || 0) + ' pending',
        subline: 'Oldest: ' + formatAgeShort(system.oldestPendingAgeSeconds)
      }
    },
    geoBackupTile () {
      const system = this.mapSystems.geoBackup || {}
      const isIdle = system.sourceState === 'idle'
      return {
        status: system.status || 'unknown',
        headline: isIdle ? 'Idle' : formatAgeShort(system.lastPersistedAgeSeconds),
        subline: isIdle
          ? 'No current geo data to persist'
          : 'Queue: ' + (system.queueLength || 0)
      }
    },
    requestQueuesTile () {
      const system = this.mapSystems.requestQueues || {}
      return {
        status: system.status || 'unknown',
        headline: (system.totalPending || 0) + ' pending',
        subline: this.formatRequestQueueSubline(system)
      }
    }
  },
  methods: {
    safeQueueLine (queue) {
      const parsedQueue = queue || {}
      return (parsedQueue.pending || 0) + ' pending • ' + (parsedQueue.processing || 0) + ' processing'
    },
    formatRequestQueueSubline (system) {
      const queues = system.queues || []
      if (!queues.length) {
        return 'No queue data'
      }
      const warningQueues = queues.filter(function (item) {
        return item.status === 'warning' || item.status === 'critical'
      })
      if (warningQueues.length) {
        return warningQueues.length + ' queue(s) need attention'
      }
      return 'All clear'
    }
  }
}
</script>
